/*
 * Mobile hamburger menu (Figma 3541:58). Index-only, mirrors the cart
 * drawer's open/close/focus-trap pattern (assets/cart-drawer.js) so the
 * two overlays behave identically even though neither shares code with
 * the other.
 *
 * The nav pill itself (sections/nav.liquid) is never touched by this file
 * except for its hamburger button, whose aria-expanded/aria-label this
 * owns and whose three bars CSS morphs into an X off that same attribute.
 * layout/theme.liquid's index-only scroll script listens for the
 * mobile-menu:open/close events below the same way it already listens
 * for cart-drawer:open/close, to lock the nav open and body scroll.
 */
(() => {
  const menu = document.querySelector('[data-mobile-menu]');
  const hamburger = document.querySelector('[data-hamburger-trigger]');
  if (!menu || !hamburger) return;

  const panel = menu.querySelector('[data-mobile-menu-panel]');
  const root = document.documentElement;

  let lastFocused = null;

  const isOpen = () => root.classList.contains('menu-open');

  const trapFocus = (e) => {
    if (e.key !== 'Tab') return;
    const focusable = Array.from(
      panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'),
    ).filter((el) => el.offsetParent !== null);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  const onKeydown = (e) => {
    if (e.key === 'Escape') {
      close();
    } else {
      trapFocus(e);
    }
  };

  const labels = window.__mobileMenuLabels || { open: 'Menu', close: 'Close menu' };

  function open() {
    if (isOpen()) return;
    lastFocused = document.activeElement;
    root.classList.add('menu-open');
    menu.setAttribute('aria-hidden', 'false');
    menu.inert = false;
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.setAttribute('aria-label', labels.close);
    window.__scrollLock?.lock();
    document.addEventListener('keydown', onKeydown);
    document.dispatchEvent(new CustomEvent('mobile-menu:open'));
    const firstRow = panel.querySelector('a[href]');
    if (firstRow) {
      // Some browsers' :focus-visible heuristic treats "script moved
      // focus to a different element than the one interacted with" as
      // visible-worthy on its own, independent of whether that
      // interaction was a tap or a keypress - the CSS :focus/:focus-visible
      // split alone isn't enough there. This class-toggle suppresses the
      // ring for this one synchronous open() call specifically, while a
      // real subsequent Tab press (which never happens on the same frame)
      // still shows it normally for keyboard users.
      firstRow.classList.add('is-programmatic-focus');
      firstRow.focus();
      requestAnimationFrame(() => firstRow.classList.remove('is-programmatic-focus'));
    }
  }

  function close() {
    if (!isOpen()) return;
    root.classList.remove('menu-open');
    menu.setAttribute('aria-hidden', 'true');
    menu.inert = true;
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.setAttribute('aria-label', labels.open);
    window.__scrollLock?.unlock();
    document.removeEventListener('keydown', onKeydown);
    document.dispatchEvent(new CustomEvent('mobile-menu:close'));
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  hamburger.addEventListener('click', () => {
    if (isOpen()) close();
    else open();
  });
})();
